import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as z from "zod/v4";

export const getTotes = {
  name: "getTotes" as const,
  input: z.object({}),
  output: z.object({
    totes: z.array(RedoFulfillmentToteSchema),
    toteGroups: z.array(RedoFulfillmentToteGroupSchema),
  }),
};

export type GetTotesInput = z.infer<typeof getTotes.input>;
